import React, { useEffect, useRef } from "react";

import theme from "@/foundation/Theme";

import {
  FixedSection,
  WrapContainer,
  LHSSection,
  RHSSection,
  StyledTitle,
  StyledCTAButton,
} from "./style";

function FloatingBanner({ title, ctaTitle, handleCorporateFormView }) {
  const bannerRef = useRef();

  const detectScroll = () => {
    window.onscroll = () => {
      const headerPos =
        document.getElementById("header")?.getBoundingClientRect()?.bottom || 0;
      const footerPos =
        document.getElementById("footer")?.getBoundingClientRect()?.top -
          window.innerHeight || 0;

      if (footerPos >= 0 && headerPos <= 0) {
        bannerRef.current.style.opacity = "1";
        bannerRef.current.style.visibility = "visible";
      } else {
        bannerRef.current.style.opacity = "0";
        bannerRef.current.style.visibility = "hidden";
      }
    };
  };

  useEffect(() => {
    if (bannerRef.current) detectScroll();
  });

  const Title = <StyledTitle variant="heading5">{title}</StyledTitle>;

  const CTAButton = (
    <StyledCTAButton
      variant="primary1"
      onClick={handleCorporateFormView}
      bgColor={theme.colors.white}
      hoverColor={theme.colors.white}
    >
      {ctaTitle}
    </StyledCTAButton>
  );

  return (
    <FixedSection ref={bannerRef}>
      <WrapContainer>
        <LHSSection>{Title}</LHSSection>
        <RHSSection>{CTAButton}</RHSSection>
      </WrapContainer>
    </FixedSection>
  );
}

export default FloatingBanner;
